import { render, staticRenderFns } from "./BloqueoMaquinas.vue?vue&type=template&id=08268006&"
import script from "./BloqueoMaquinas.vue?vue&type=script&lang=js&"
export * from "./BloqueoMaquinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports